
export default {
        appName:"Futren",
home:"Home",
about:"About",
products:"Products",
service:"Service",
btn_trade:"Start Investing",
btn_cs:"Appointment Consultation",
btn_contact:"Contact Us",
btn_more:"Learn More",
theme:{
title:"Professional Financial Investment Consultant <br><span>Help You Increase Your Wealth</span>",
desc:"Provide high-quality CFD trading strategies and comprehensive investment portfolio advice to make your funds more secure and efficient."
},
model1:{
title:"Professional Investment Advisory Service",
desc:"We provide comprehensive financial investment services to help you achieve wealth appreciation and asset preservation.",
li01:{
title:"CFD Trading Strategy",
desc:"Provide professional advice and strategies for CFD trading to help you seize trading opportunities in various markets."
},
li02:{
title:"Portfolio Management",
desc:"Provide professional advice and strategies for CFD trading to help you seize trading opportunities in various markets."
},
li03:{
title:"Financial Planning",
desc:"Provide professional advice and strategies for CFD trading to help you seize trading opportunities in various markets."
},
},
model2:{
title:"Our Products",
desc:"Our Products",
more:"View More Services",
li01:{
title:"Foreign Exchange/Futures",
desc:"Diversified foreign exchange and futures market sharing, tailor-made smart strategies and trading signals"
},
li02:{
title:"Stocks",
desc:"In-depth research on global stock trends, providing exclusive data models and strategy recommendations"
},
li03:{
title:"Index",
desc:"Focus on the performance of major market indices, intelligently push trend signals and risk warnings"
},
li04:{
title:"Precious Metals",
desc:"Focus on precious metal markets such as gold and silver, and customize quantitative strategies and real-time analysis for you"
}
},
model3:{
title:"Our Promise",
desc:"Whether you are an experienced trader or a beginner, we will provide you with the tools you need to trade with confidence",
li01:{
title:"Built by traders, for traders",
desc:"Through in-depth research, data science methods and unique industry insights, we have created an easy-to-use platform while helping traders continuously improve their trading skills."
},
li02:{
title:"Never Stop",
desc:"The reason why we can provide a smooth user experience is that we insist on continuous improvement, constantly optimize the platform, and focus on providing innovative technology-driven tools to help traders trade more confidently and make smarter decisions."
},
li03:{
title:"Always Be Transparent",
desc:"We are committed to breaking down trading barriers, providing the most transparent fee standards in the industry, and providing clear, easy-to-understand and content-rich trading strategies."
},
li04:{
title:"Continuously improve professional capabilities",
desc:"Our global team has a decade of experience and deep expertise in trading technology, backed by an easy-to-use, technology-driven, and intuitive platform."
}
},
model4:{
title:"Stay connected with groups",
desc:"Stay connected with your closest groups through simple group and community messages."
},
guide_home:{
li01:{
title:"13",
desc:"Years of industry experience"
},
li02:{
title:"50+",
desc:"Professional consulting team"
},
li03:{
title:"10,000+",
desc:"Number of customers served"
},
li04:{
title:"2 billion+",
desc:"Amount of assets under management"
}
},
//About
aboutModel:{
title:"About Futren",
desc:"Futren Consultants is committed to providing customers with professional and comprehensive financial investment consulting services, and working with customers to create a wealth future.",
model1:{
label:"Corporate Culture",
title:"Our Mission, Vision and Values",
desc:"These core concepts guide our daily operations and long-term development, and are the basis for us to create value for our customers.",
li01:{
title:"Our Mission",
desc:"Through professional financial investment consulting services, we help customers achieve wealth appreciation and asset preservation, and safeguard their financial future. We are committed to providing each customer with customized investment solutions to help them achieve their financial goals and dreams."
},
li02:{
title:"Our Vision",
desc:"To become China's most trusted financial investment consulting service provider, leading industry standards and service innovation. We hope to enhance customers' investment experience and results through our professional services, while promoting the healthy development of the financial market and the promotion of inclusive finance."
},
li03:{
title:"Our Values",
desc:"Professionalism: Continuous learning and professional growth to provide customers with the most professional services. Integrity: Adhere to honesty and trustworthiness, transparent operation, and win the long-term trust of customers. Innovation: Embrace change, continue to innovate, and lead the development of the industry. Win-win: Grow together with customers, employees and partners to achieve win-win results for all parties."
},
},
model2:{
label:"Development History",
title:"Our Growth Footprint",
desc:"From the beginning of its establishment to the current industry leader, every step has witnessed our persistence and innovation.",
li01:{
title:"2015",
desc:"Futren was established in Hong Kong, initially focusing on providing personal financial management and investment consulting services to high-net-worth individuals."
},
li02:{
title:"2017",
desc:"The business expanded to the CFD trading field, established a cooperative relationship with an internationally renowned trading platform, and began to provide customers with more diversified investment options."
},
li03:{
title:"2018",
desc:"Established an investment research department, introduced a group of research and analysis experts, began to publish market research reports and investment strategy analysis, and enhanced the company's professional influence."
},
li04:{
title:"2020",
desc:"Develop and launch a self-developed investment portfolio management platform to provide customers with a more intuitive and convenient asset management experience, and set up branches around the world."
},
li05:{
title:"2024",
desc:"Implement a digital transformation strategy, upgrade the customer service platform, introduce artificial intelligence and big data technology, and enhance investment analysis and customer service capabilities."
},

},
model3:{
title:"Global Offices",
contactInfo:"Or please contact us by email with basic information about your company and the services you would like to know more about. We will get back to you as soon as possible. support {'@'}ftrademarkets.com",
li01:{
title:"Hong Kong",
desc:`Room 2509-12, 25/F, Tower 6, Gateway, Harbour City, Kowloon, Hong Kong<br>
Customer Service Hotline<br>
400-1208-921<br>
Weekdays: 9:00-18:00`
},
li02:{
title:"Melbourne",
desc:`121 Exhibition Street, Melbourne, Victoria 3000 Australia<br>
Customer Service Hotline<br>
+61 3 9651 8100<br>
Weekdays: 9:00-17:00`
},
li03:{
title:"London",
desc:`2nd Floor East, Goldsmiths Building, Temple District, London<br>
Customer Service Tel<br>
+44 020 3036 0264<br>
Weekdays: 9:00-17:00`
}

},
guide:{
title:"Start your wealth appreciation journey with us",
desc:"We look forward to establishing a long-term cooperative relationship with you and providing you with professional financial investment advisory services."
}
},
//Products
productsModel:{
title:"Our Products",
desc:"We are committed to helping you make smarter trading decisions. Read on to learn why we are different and join an active community of over 720,000 CFD traders.",
model1:{
label:"CFD Trading Smart Strategy",
title:"CFD Smart Strategy Service",
desc:"Relying on advanced quantitative modeling and big data analysis, we provide CFD market users with exclusive smart signals, automated strategies and trend analysis tools for a variety of financial asset classes. Our solutions are committed to helping investors understand market changes, seize market opportunities, and improve decision-making efficiency.",
li01:{
title:"Smart Signal Push",
desc:"- Based on a multi-factor quantitative model, it outputs buy and sell tips and market change alerts around the clock. Escort."
},
li02:{
title:"Strategy Subscription Support",
desc:"- Multiple style strategies can be subscribed on demand to adapt to different market needs and risk preferences"
},
li03:{
title:"Multi-market data analysis",
desc:"- Integrated tracking of foreign exchange, index, precious metals and other market trends, providing multi-angle insights"
},
li04:{
title:"Risk warning tool",
desc:"- Built-in multiple risk control models, instant diagnosis of market risks, and assistance in adjusting investment strategies"
},
},
model2:{
label:"Investment Portfolio",
title:"Smart Portfolio Management",
desc:"Our portfolio management service uses modern investment theory and advanced data analysis technology to create the most optimized diversified asset allocation plan for you. Through the combination of intelligent algorithms and professional consultants, we continuously monitor and adjust your portfolio to achieve long-term and stable returns.",
li01:{
title:"Asset Diversification",
desc:"- Cross-asset class allocation to reduce single market risks"
},
li02:{
title:"Personalized Customization",
desc:"- Tailored according to your risk tolerance and investment goals"
},
li03:{
title:"Continuous Rebalancing",
desc:"- Regularly adjust asset allocation to maintain optimal investment status"
},
li04:{
title:"Performance Tracking",
desc:"- Real-time monitoring of investment performance and detailed report analysis"
}
},
model3:{
label:"Risk Management",
title:"Comprehensive Risk Management Tools",
desc:"We provide advanced risk management tools and solutions to help investors identify, evaluate and mitigate investment risks. Through quantitative models and professional analysis, we help you effectively control risk exposure while pursuing returns.",
li01:{
title:"Risk Assessment",
desc:"- Multi-dimensional assessment of portfolio risk and identification of potential problems"
},
li02:{
title:"Stress Testing",
desc:"- Simulate extreme market conditions and evaluate the resilience of the portfolio"
},
li03:{
title:"Risk Warning",
desc:"- Real-time monitoring, timely detection and notification of abnormal risks"
},
li04:{
title:"Hedging Strategy",
desc:"- Provide a variety of market hedging tools to smooth investment fluctuations"
}
},
guide:{
title:"Ready to start your investment journey?",
desc:"Contact our professional consultants to get personalized investment advice and product recommendations."
}
},
//Service
serviceModel:{
title:"Strategic Analysis Consultant",
desc:"We provide a full range of professional financial services to help you plan your financial future, increase your wealth, and protect your assets.",
model1:{
label:"Our service types",
title:"Full range of financial advisory services",
desc:"Whether you are an individual investor or an institutional client, we can provide professional solutions to meet your needs. (CFD) is a financial derivative that allows you to trade various market price changes without owning the underlying assets. Through CFD trading, you can speculate or hedge on a variety of markets such as stocks, indices, foreign exchange, commodities, etc. without holding actual assets.",
li01:{
title:"Investment Strategy Consulting",
desc:"Based on market trends and your investment goals, we provide professional investment strategy advice to help you make wise investment decisions. Services include market analysis, asset allocation recommendations, and stock/fund screening.",
item01:"Market Trend Analysis",
item02:"Investment Opportunity Identification",
item03:"Portfolio Recommendations"
},
li02:{
title:"Wealth Management",
desc:"Comprehensive wealth management services to help you protect and grow your assets. Our professional team will develop long-term wealth planning and management plans based on your financial situation and goals. / Fund screening, etc.",
item01:"Asset allocation optimization",
item02:"Return and risk balance",
item03:"Regular performance evaluation"
},
li03:{
title:"Corporate financial services",
desc:"Provide corporate customers with a full range of financial consulting services, including financing plans, financial planning, investment management and risk control, to help companies optimize their financial structure and achieve sustainable development. / Fund screening, etc.",
item01:"Corporate financing consulting",
item02:"Capital structure optimization",
item03:"M&A restructuring advice"
},
li04:{
title:"Risk management consulting",
desc:"Help you identify and manage various risks in your investment and ensure the safety of your assets. We provide risk assessment, prevention strategies and crisis response plans to make your investment safer and more reliable. / Fund screening, etc.",
item01:"Risk assessment and analysis",
item02:"Hedge strategy formulation",
item03:"Loss control mechanism"
},
li05:{
title:"Investment education and training",
desc:"Provide professional investment knowledge training and education courses to help investors improve their investment skills and knowledge. Including online and offline courses, seminars and one-on-one guidance. / Fund screening, etc.",
item01:"Investment basics",
item02:"Market analysis skills",
item03:"Trading strategy training"
},
li06:{
title:"Retirement planning",
desc:"Provide comprehensive retirement planning services to help you prepare financially for retirement. We will consider your retirement goals, time frame and budget to develop a retirement investment plan that suits you. / Fund screening, etc.",
item01:"Retirement needs analysis",
item02:"Long-term investment planning",
item03:"Income source optimization"
},
},
guide:{
title:"Start your wealth appreciation journey",
desc:"Book a free consultation now and let our professional team develop a personalized investment plan for you."
}
},
//Futureinvest app
futureInvest:{
year:"years",
theme:{
title:"Global market, trading at your fingertips<br>Ups and downs are opportunities, wealth is within reach!",
subTitle:"The trusted choice of 12 million traders",
openAccount:"Open an account",
joinNow:"Join now"
},
model1:{
desc01:"Industry deep cultivation",
desc02:"Supported countries",
desc03:"Traders",
desc04:"Trading varieties"
},
model2:{
title:"About FUTREN",
desc:"Founded in 2015, the world's top ten CFD trading platform in terms of real trading volume, providing safe, reliable, real and transparent trading services to more than 26 million users."
},
model3:{
title:"Trustworthy and secure trading platform",
li01:{
title:"Quick account opening",
desc:"Open real and demo accounts in 1 minute"
},
li02:{
title:"Enjoy rebates for friends' trading",
desc:"The more you invite, the more rebates"
},
li03:{
title:"",
desc:"Spread as low as 0.1"
},
li04:{
title:"CFD trading 24/7",
desc:"Open all year round, capture global market at any time"
}
},
productsModel:{

label:"Our products",
title:"Contract for Difference Trading",
desc:"Contract for Difference (CFD) is a financial derivative that allows you to trade various market price changes without owning the underlying assets. Through CFD trading, you can speculate or hedge on a variety of markets such as stocks, indices, foreign exchange, commodities, etc. without holding actual assets.",
li01:{
title:"Flexible leverage",
desc:"- Use leverage to amplify your trading funds and obtain greater profit potential. Escort."
},
li02:{
title:"Two-way trading",
desc:"- You can go long or short, and there are profit opportunities in any market direction"
},
li03:{
title:"Diverse markets",
desc:"- One platform can trade multiple financial markets around the world"
},
li04:{
title:"Risk control management",
desc:"- Provide stop loss and take profit orders to help control and manage risks"
},

},
model4:{
title:"Honorary awards",
hostory:"Years of history",
license:"Regulatory license",
award:"Award",
li01:{
title:"Most Trusted CFD Broker Award",
desc:"International 2024"
},
li02:{
title:"Global Best Customer Fund Security Award",
desc:"International 2024"
},
li03:{
title:"Excellent Digital Trading Experience Award",
desc:"Asia Pacific 2025"
}
},
guide:{
title:"Start your CFD trading journey now",
desc:"Make an appointment for a free consultation now and let our professional team develop a personalized investment plan for you. "
}
},
footer:{
risk1:`Risk Warning<br>
Contracts for Difference (CFDs) are complex financial instruments. While leveraged trading may magnify gains, it can also increase the risk of loss and lead to a rapid loss of funds. Data shows that 85.24% of retail investors lose money when trading CFDs using the provider's services. Before trading, please ensure that you fully understand how CFDs work and carefully assess whether you can afford the high risk of losing your money.
<br><br>
Disclaimer: <br>
Futren Ltd, an International Business Company (IBC) duly organized under the laws of Saint Lucia, has its registered address at Sotheby Building, Rodney Village, Rodney Bay, Gros Islet, Saint Lucia.
Futren is authorized to conduct the following activities to professional investors worldwide: providing financial product advice, trading in financial products, and acquiring or disposing of financial products on behalf of others. General Advice Warning: This advice may not be suitable for you as it contains general advice that does not take into account your personal circumstances. All strategies and information provided on this website are for informational purposes only. Please make an appointment to seek personal financial and tax advice before acting on this information.
`,
risk2:`Thank you for choosing our financial services. Investment is risky and you should be cautious when entering the market. Financial markets are volatile and may result in loss of principal. Past performance does not represent future performance. The analysis, suggestions or product information we provide are for reference only and do not constitute any investment advice or commitment. Please make prudent decisions based on your own risk tolerance, financial situation and investment goals.

The company is not responsible for investment losses caused by market changes, policy adjustments or other force majeure factors. You must bear all risks of investment decisions. It is recommended that you fully understand the relevant products before investing and consult professional consultants when necessary.

This statement is an important agreement on the rights and obligations of both parties. Please read it carefully. Continuing to use this service is deemed that you have understood and agreed to the above risk warnings and disclaimers. `,
copyright:"Futren Limited All rights reserved.",
contact:`You can also contact:<br><br>
Customer service phone<br>
400-1208-921<br>
Working days: 9:00-18:00<br><br>

Email<br>
support {'@'}ftrademarkets.com`,
privacy:"Privacy Policy",
clientAgreement:"Customer Agreement"
},
platform:{
title:"A cloud messaging application",
subTitle:"Focus on security and speed",
downBtn:"Download and chat",
downloading:"Redirecting to download...",
downloadHint:"Please wait",
}
    
    
}